import {POINT, QUEST} from "../constants/model-type"

// marker visibility by current preferences filters and search
export const isModelVisible = (data: any): boolean => {
    const settings = window.localSettings

    if (
        settings.searchValue &&
        !data.isSearched(settings.searchValue.toLowerCase())
    ) {
        return false
    }

    switch (data.type) {
        case POINT:
            if (data.triangulationType) {
                return !settings.hiddenTriangulationTypes.includes(data.triangulationType)
            }
            if (data.isCustom) {
                return settings.showCustomPoints
            }
            return !settings.hiddenPointTypes.includes(data.icon)
        case QUEST:
            return !settings.hiddenQuestTypes.includes(data.icon) &&
                   !settings.hiddenCategoryTypes.includes(data.category)
        default:
            return false
    }
}

export const toggleArrayValue = (arr: any[], value: any, options?: { mandatorySelection?: boolean }): any[] => {
    let newArr = arr.slice()
    if (newArr.includes(value)) _.remove(newArr, (v: any) => v === value)
    else newArr.push(value)

    if (options?.mandatorySelection && newArr.length === 0) newArr = arr.slice()

    return newArr
}

export const getCoordinates = (str: string): { lat: number; lng: number } | false => {
    const regexp = /(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)/gi
    const match = str.match(regexp)
    if (_.isEmpty(match)) return false

    const coordinates = match![0].split(', ')
    return {
        lat: parseFloat(coordinates[0]),
        lng: parseFloat(coordinates[1])
    }
}

export const generateUIDWithCollisionChecking = (arrayIds: string[] = []): string => {
    const _generatedUIDs: Record<string, number | boolean> = arrayIds.reduce(
        (a: Record<string, number>, key: string) => Object.assign(a, { [key]: 0 }), {}
    )

    while (true) {
        const uid = ("0000" + ((Math.random() * Math.pow(36, 4)) | 0).toString(36)).slice(-4)
        if (!_generatedUIDs.hasOwnProperty(uid)) {
            _generatedUIDs[uid] = true
            return uid
        }
    }
}

export const lightenDarkenColor = (colorCode: string, amount: number): string => {
    let usePound = false

    if (colorCode[0] === "#") {
        colorCode = colorCode.slice(1)
        usePound = true
    }

    const num = parseInt(colorCode, 16)

    let r = (num >> 16) + amount
    if (r > 255) r = 255
    else if (r < 0) r = 0

    let b = ((num >> 8) & 0x00FF) + amount
    if (b > 255) b = 255
    else if (b < 0) b = 0

    let g = (num & 0x0000FF) + amount
    if (g > 255) g = 255
    else if (g < 0) g = 0

    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16)
}
